import React from "react";
import { Outlet } from "react-router-dom";
import PropTypes from "prop-types";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";

interface MainLayoutProps {
  hasFooter: boolean
}

function MainLayout({ hasFooter }: MainLayoutProps) {
  return (
    <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
      <Header />
      <Outlet />
      {hasFooter && <Footer />}
    </div>
  );
}

MainLayout.propTypes = {
  hasFooter: PropTypes.bool.isRequired,
};

export default MainLayout;
